export interface AvatarOption {
  key: string
  label: string
  src: string
}

export const DEFAULT_AVATAR_OPTION: AvatarOption = {
  key: 'generic',
  label: 'Classic Crest',
  src: '/avatars/generic.png',
}

export const AVATAR_OPTIONS: AvatarOption[] = [
  { key: 'mentor-01', label: 'Mentor Sunrise', src: '/avatars/avatar-mentor-01.png' },
  { key: 'mentor-02', label: 'Mentor Twilight', src: '/avatars/avatar-mentor-02.png' },
  { key: 'mentor-03', label: 'Mentor Azure', src: '/avatars/avatar-mentor-03.png' },
  { key: 'mentor-04', label: 'Mentor Evergreen', src: '/avatars/avatar-mentor-04.png' },
  { key: 'mentor-05', label: 'Mentor Ember', src: '/avatars/avatar-mentor-05.png' },
  { key: 'guide-01', label: 'Guide Dawn', src: '/avatars/avatar-guide-01.png' },
  { key: 'guide-02', label: 'Guide Horizon', src: '/avatars/avatar-guide-02.png' },
  { key: 'guide-03', label: 'Guide Harbor', src: '/avatars/avatar-guide-03.png' },
  { key: 'guide-04', label: 'Guide Summit', src: '/avatars/avatar-guide-04.png' },
  { key: 'guide-05', label: 'Guide Lumen', src: '/avatars/avatar-guide-05.png' },
]

export const ALL_AVATAR_OPTIONS: AvatarOption[] = [DEFAULT_AVATAR_OPTION, ...AVATAR_OPTIONS]

export const AVATAR_MAP = ALL_AVATAR_OPTIONS.reduce<Record<string, AvatarOption>>((acc, option) => {
  acc[option.key] = option
  return acc
}, {})

export const DEFAULT_AVATAR_KEY = DEFAULT_AVATAR_OPTION.key
export const DEFAULT_AVATAR_SRC = DEFAULT_AVATAR_OPTION.src

export function normalizeAvatarKey(raw?: string | null): string | null {
  if (!raw) return null
  const trimmed = raw.trim()
  if (!trimmed) return null

  if (AVATAR_MAP[trimmed]) {
    return trimmed
  }

  const withoutDomain = trimmed.replace(/^https?:\/\/[^/]+\//, '').replace(/^\/+/, '')
  const filename = withoutDomain.split('/').pop() ?? withoutDomain
  const withoutExtension = filename.replace(/\.[^.]+$/, '')

  if (AVATAR_MAP[withoutExtension]) {
    return withoutExtension
  }

  if (withoutExtension.startsWith('avatar-')) {
    const candidate = withoutExtension.replace(/^avatar-/, '')
    if (AVATAR_MAP[candidate]) {
      return candidate
    }
  }

  return trimmed
}

export function getAvatarAsset(key?: string | null) {
  const normalized = normalizeAvatarKey(key)
  if (normalized && AVATAR_MAP[normalized]) {
    return AVATAR_MAP[normalized]
  }

  const raw = key?.trim()
  if (raw && (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('/'))) {
    return {
      key: raw,
      label: 'Profile picture',
      src: raw,
    }
  }

  return DEFAULT_AVATAR_OPTION
}
